<script lang="ts">
    import {
        ExperimentalSettingTooltip,
        type SettingDescription,
        type SettingId,
        type SettingValue,
    } from "../lib/Settings";
    import experimentIcon from "../assets/experiment.svg?raw";

    export let value: boolean;
    export let description: SettingDescription<boolean>;
    export let updateSetting: (id: SettingId, value: boolean) => void;

    // Triggered only on change
    $: updateSetting(description.id, value);

    let checkbox: HTMLInputElement;
</script>

<label class="settings-toggle no-tooltip-underline">
    <input
        name={description.id}
        type="checkbox"
        role="switch"
        bind:checked={value}
    />
    <div class="setting-title">
        <p>
            <b>{description.description}</b>
        </p>
        {#if description.isExperimental}
            <div
                class="no-tooltip-underline"
                data-tooltip={ExperimentalSettingTooltip}
            >
                {@html experimentIcon}
            </div>
        {/if}
    </div>
    <span>{description.tooltip}</span>
</label>
